<template>
    <el-dialog title="选择回传方案" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
            <!--<el-form-item label="方案ID" prop="id">-->
                <!--<el-input type="number" v-model="formInline.id" placeholder="请输入方案ID" clearable  @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="方案名称" prop="strategyName">
                <el-input v-model="formInline.strategyName" placeholder="请输入方案名称" clearable  @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
            </el-form-item>
            <!--<el-form-item label="回传类型" prop="type" style="margin-right: 30px;">-->
                <!--&lt;!&ndash; clearable  :disabled="typeVal !== item.value"&ndash;&gt;-->
                <!--<el-select v-model="formInline.type" placeholder="请选择回传类型" @change="search" style="width: 180px;">-->
                    <!--<el-option-->
                        <!--v-for="item in typeOptions"-->
                        <!--:key="item.value"-->
                        <!--:label="item.label"-->
                        <!--:value="item.value"-->
                    <!--&gt;</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tableTh">
            <!-- 免费回传列表 -->
            <el-table  :data="tableData.result" ref="singleTable" border  highlight-current-row
                    @current-change="handleCurrentChangeTable" row-key="id" style="width: 100%;" class="tableStyle table-radio">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="方案ID"
                        width="110">
                </el-table-column>
                <el-table-column prop="strategyName" label="方案名" width="110">
                </el-table-column>
				<el-table-column
						label="回传付费金额"
						width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.callBackAmount == 1">是</span>
						<span v-if="scope.row.callBackAmount == 0">否</span>
					</template>
				</el-table-column>
				<el-table-column label="回传配置" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.returnCaliber == 0">全部回传配置</span>
						<span v-if="scope.row.returnCaliber == 1">卡回传配置</span>
					</template>
				</el-table-column>
				<el-table-column label="回传规则">
					<template slot-scope="scope">
						<div v-if="scope.row.returnCaliber == 0">
							<span v-if="scope.row.returnCaliberParam == 1">回传用户当天自然日所有充值</span>
							<span v-if="scope.row.returnCaliberParam == 2">回传用户当天自然日的首充</span>
						</div>
						<div class="td-info" v-if="scope.row.returnCaliber == 1">
							<p>回传维度：按计划回传</p>
							<p>回传保护数：{{scope.row.returnProtection}}</p>
							<p>回传规则：</p>
							<ul>
								<li v-for="(item, index) in scope.row.partReturnData" :key="index">
									<span>{{item.minTopUpAmount}}-{{item.maxTopUpAmount}}：</span>
									<span v-if="item.returnWay == 2">全部回传</span>
									<span v-if="item.returnWay == 0">全部不回传</span>
									<span v-if="item.returnWay == 1">
                                            传{{item.returnPercent}}漏{{item.returnLeach}}
                                        </span>
								</li>
							</ul>
						</div>
					</template>
				</el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[5, 20, 50, 100, 200, 500]"
                    :page-size="tableData.pageSize"
                    background
                    :current-page="currentPage"
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { list} from "@/api/wb/promanage/return";
export default {
    name: 'ReturnTable',
    // props: {
    //     visible: {
    //         type: Boolean,
    //         required: true
    //     },
    //     selectReturn: {
    //         type: Object,
    //         required: true
    //     },
    //     postbackId: Number
    // },
    props:['visible', 'selectReturn', 'wxAppId'],
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                id: '',
                strategyName: ''
            },
            typeOptions: [
                // {
                //     value: 1,
                //     label: '免费回传',
                // },
                {
                    value: 2,
                    label: '付费回传',
                },
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 5,
            currentRow: '',
            typeVal:'',
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            this.$nextTick(()=>{
                this.$refs.singleTable.setCurrentRow(this.selectReturn)
                // if(this.posterId){
                //     this.typeVal = 1
                //     this.formInline.type == 1
                // }
                // if(this.rechargeId){
                //     this.typeVal = 2
                //     this.formInline.type == 2
                // }
                // if (this.postbackId) {
                //     console.log(this.postbackId)
                //     const row = this.tableData.result.find(row => row.id === this.postbackId);
                //     this.$refs.singleTable.setCurrentRow(row);
                // } else {
                //     this.$refs.singleTable.setCurrentRow(this.selectReturn)
                // }
            })
        },
        // svId(newValue) {
        //     this.svId = newValue
        //     this.getTableData()
        // },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableData()
        },
        resetQuery: function(){
            this.$refs['formInline'].resetFields()
            this.getTableData()
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableData()
        },
        // 单选
        handleCurrentChangeTable(val) {
            console.log(val)
            this.$refs.singleTable.setCurrentRow(val);
            this.currentRow = val
            this.selected = [val.id]
            console.log(this.selected)
        },
        // 确定按钮
        tableSureBtn() {
            this.$emit('returnSure', this.currentRow);
            this.$emit('cancelDialogReturn', false);
            // this.closeDialogTable()
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log('关闭弹框')
            this.$emit('cancelDialogReturn', false);
            // this.$refs.singleTable.setCurrentRow();
            // this.selected = []
        },
        getTableData() {
            let json2 = {
                appId: this.wxAppId,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            list(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
    }
}
</script>
